import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Urunler.css';

const kategoriGorselleri = {
  "Vidalı Kompresörler": "/images/kategoriler/vidali.png",
  "Turbo Kompresörler": "/images/kategoriler/turbo.png",
  "Pistonlu Kompresörler": "/images/kategoriler/pistonlu.png",
  "Yağsız Kompresörler": "/images/kategoriler/yagsiz.png",
  "Kurutucular": "/images/kategoriler/kurutucu.png",
  "Hava Tankları": "/images/kategoriler/havatanki.png",
  "Ekipmanlar": "/images/kategoriler/ekipman.png"
};

const Urunler = () => {
  const [kategoriler, setKategoriler] = useState([]);

  useEffect(() => {
    fetch('/urunler.json')
      .then(res => res.json())
      .then(data => {
        const tumKategoriler = [...new Set(data.map(u => u.kategori))];
        setKategoriler(tumKategoriler);
      })
      .catch(err => {
        console.error('❌ urunler.json veri çekme hatası:', err);
        alert('Ürün verileri yüklenemedi. Lütfen urunler.json dosyasını kontrol edin.');
      });
  }, []);

  return (
    <div className="urunler-container">
      <h1>Ürün Kategorileri</h1>
      <div className="kategori-grid">
        {kategoriler.map((kat, i) => (
          <Link
            key={i}
            to={`/urunler/${encodeURIComponent(kat)}`}
            className="kategori-card"
          >
            <img src={kategoriGorselleri[kat] || '/images/bos-urun.jpg'} alt={kat} />
            <h4>{kat}</h4>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Urunler;
